import React from 'react'

const AdminNotification = () => {
    return (
        <div>

        </div>
    )
}

export default AdminNotification
